import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import { transformStr3, handleHttp, getformListItemsdatas, colorConfig } from "@/utils/utils";
export default {
  data() {
    return {
      params: {
        deptId: this.$route.query.fid,
        formId: '595257',
        page: 1,
        limit: 10,
        searchStr: ''
      },
      themebg: require('../assets/audioGuide/topbg.jpg')
    };
  },
  created() {
    this.getTheme();
  },
  methods: {
    resetAudioDetailImgFit() {
      document.documentElement.style.removeProperty('--audio-detail-img-fit');
    },
    setAudioDetailImgFit(imgShowType) {
      const fitMap = {
        '填充': 'fill',
        '适应': 'cover',
        '原尺寸': 'contain'
      };
      const fitType = fitMap[imgShowType];
      if (!fitType) return;
      document.documentElement.style.setProperty('--audio-detail-img-fit', fitType);
    },
    // 获取讲解主题设置表单数据
    getTheme() {
      this.resetAudioDetailImgFit();
      this.$api.singleadvanceSearch(this.params).then(res => {
        if (!res.totalRow) return;
        res.dataList.forEach((item, index) => {
          let itemformdata = item.formIdValueData;
          let itemformat = {};
          Object.keys(itemformdata).forEach(key => {
            itemformat[transformStr3(itemformdata[key].alias)] = getformListItemsdatas(itemformdata[key]);
          });
          item.itemformdata = itemformat;
        });
        let tconfig = res.dataList[0].itemformdata;
        console.log(tconfig, 'tconfig');
        this.setAudioDetailImgFit(tconfig.imgShowType);
        if (tconfig.imageDown && tconfig.imageDown == '关闭') {
          document.getElementById('app').classList.add('noSaveImg');
          this.$parent.imgHide = true;
        }
        if (tconfig.title) document.title = tconfig.title;
        if (tconfig.color.length) colorConfig(tconfig.color, '--audio-theme');
        if (tconfig['23'] && tconfig['23'].length) colorConfig(tconfig['23'], '--audio-bg-theme');
        if (tconfig['24'] && tconfig['24'].length) this.themebg = handleHttp(tconfig['24'][0].fileUrl);
      });
    }
  }
};